import { Box } from '@mui/material';

import { Logo } from 'src/components/Logo';
import { useMe } from '@hooks/useMe';

const MenuLogo = ({ small = false, withoutStyles = false }) => {
  const styles = small ? { display: 'flex', justifyContent: 'center', py: 2.5 } : { pl: 3.5, pt: 2.5, pb: 1 };
  const { currentUser } = useMe();
  return (
    <Box sx={withoutStyles ? {} : styles}>
      {currentUser?.company.logoUrl ? (
        <img alt="logo" src={currentUser?.company.logoUrl} style={{ objectFit: 'scale-down' }} height="60px" />
      ) : (
        <Logo />
      )}
    </Box>
  );
};

export default MenuLogo;
